import type { PartnerBalanceTransactionResponseDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { defaultTableConfig } from "Infrastructure/Utilities/defaultTableConfig";
import { usePartnerBalance } from "Partner/Api/Query/useBalanceByPartnerId";
import { Typography } from "@mui/material";
import { createMRTColumnHelper, type MRT_Row } from "material-react-table";

type BalanceTableRow = PartnerBalanceTransactionResponseDto & {
	price?: string;
};

const balanceTableResource = Resources.base.partner.balanceTable;

export const usePartnerBalanceTable = (partnerId: number) => {
	const { t } = useResource();
	const columnHelper = createMRTColumnHelper<BalanceTableRow>();
	const { data, isLoading } = usePartnerBalance(partnerId);

	const columns = [
		columnHelper.accessor("id", {
			id: "id",
			header: t(balanceTableResource.id),
			enableColumnActions: false,
			maxSize: 60,
			minSize: 0,
			grow: 0,
			Cell: ({ row }: { row: MRT_Row<BalanceTableRow> }) => (
				<Typography variant="body2">{row.original.id}</Typography>
			),
		}),
		columnHelper.accessor("type", {
			id: "type",
			header: t(balanceTableResource.type),
			enableColumnActions: false,
			maxSize: 60,
			minSize: 0,
			grow: 0,
			Cell: ({ row }: { row: MRT_Row<BalanceTableRow> }) => (
				<Typography variant="body2">{row.original.type}</Typography>
			),
		}),
		columnHelper.accessor("description", {
			id: "description",
			header: t(balanceTableResource.description),
			enableColumnActions: false,
			maxSize: 60,
			minSize: 0,
			grow: 0,
			Cell: ({ row }: { row: MRT_Row<BalanceTableRow> }) => (
				<Typography variant="body2">
					{row.original.description || ""}
				</Typography>
			),
		}),

		columnHelper.accessor("amount", {
			id: "amount",
			header: t(balanceTableResource.amount),
			enableColumnActions: false,
			maxSize: 60,
			minSize: 0,
			grow: 0,
			Cell: ({ row }: { row: MRT_Row<BalanceTableRow> }) => (
				<Typography variant="body2">{row.original.amount}</Typography>
			),
		}),
		columnHelper.accessor("vat", {
			id: "vat",
			header: t(balanceTableResource.vat),
			enableColumnActions: false,
			maxSize: 60,
			minSize: 0,
			grow: 0,
			Cell: ({ row }: { row: MRT_Row<BalanceTableRow> }) => (
				<Typography variant="body2">{row.original.vat}</Typography>
			),
		}),
		columnHelper.accessor("monthTag", {
			id: "monthTag",
			header: t(balanceTableResource.monthTag),
			enableColumnActions: false,
			maxSize: 60,
			minSize: 0,
			grow: 0,
			Cell: ({ row }: { row: MRT_Row<BalanceTableRow> }) => (
				<Typography variant="body2">{row.original.monthTag}</Typography>
			),
		}),
		// columnHelper.accessor("status", {
		// 	id: "status",
		// 	header: t(balanceTableResource.status),
		// 	enableColumnActions: false,
		// 	maxSize: 60,
		// 	minSize: 0,
		// 	grow: 0,
		// 	Cell: ({ row }: { row: MRT_Row<BalanceTableRow> }) => (
		// 		<Typography variant="body2">{row.original.status}</Typography>
		// 	),
		// }),
	];

	const tableOptions = {
		...defaultTableConfig,
		columns,
		data: data ?? [],
		state: {
			showSkeletons: isLoading,
			isLoading,
		},
	};

	return tableOptions;
};
